import loadSlick from '../helpers/loadSlick';

const $slider = $('.js-integration-slider');

const integrationSlider = {
  initialize() {
    if ($slider.length) {
      loadSlick().then(() => {
        this.create();
      });
    }
  },

  create() {
    const options = $slider.data();

    const config = {};

    if (typeof options !== 'undefined') {
      const optionKeys = Object.keys(options);

      optionKeys.forEach((option) => {
        const regex = new RegExp('^slider', 'g');

        if (regex.test(option)) {
          let transformedOption = option.replace('slider', '');
          transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

          config[transformedOption] = options[option];
        }
      });
    }

    $slider.slick(config);

    if ($slider.hasClass('slick-initialized')) {
      $slider.on('setPosition', (event, slick) => {
        slick.$slides.css({
          height: `${slick.$slideTrack.height()}px`,
          width: `${slick.$slideTrack.height()}px`,
        });
      });
    }
  },
};

export default integrationSlider;
